














































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import Filtrate from '../Filtrate/index.vue'
import { listTwoTag, listLabel, listOneLabel } from '@/api/product'

@Component({
  name: 'FiltrateBox',
  components: {
    Filtrate
  }
})
export default class FiltrateBox extends Vue {
  @Prop({
    type: [Number, String],
    default: ''
  }) private treeId!: number | string

  @Prop({
    type: Boolean,
    default: ''
  }) private value!: boolean

  @Prop({
    type: Array,
    default: () => ([])
  }) private LabelList!: any[]

  // type = 1:百灵文旅, tagId=296:春季踏青活动专区
  @Prop({
    type: Number,
    default: 0
  }) private type!: number

  private showAll = false

  private labelId: string | number = ''

  // 二级标签
  private TwoTagList: any[] = []

  private minPrice: string | number = ''

  private maxPrice: string | number = ''

  // 因为标签ID是唯一的,又是多选，所以可以多个共用一个数组
  private tagIdsList: any[] = []

  // 最终的 产品分类数据一级标签数据
  protected labelList:any = []

  // 单选切换
  @Emit('radio')
  private changeRadio (item) {
    this.tagIdsList = []
    this.getListTwoTag(item)
    return item
  }

  private inputMaxPrice (value) {
    this.maxPrice = value.replace(/\D/g, '')
  }

  private inputMinPrice (value) {
    this.minPrice = value.replace(/\D/g, '')
  }

  // 获取产品标签分类
  private async getListLabel () {
    // 1 -> 先拿到所有的 获取产品标签分类
    const res = await listLabel({
      labelType: 1
    })
    if (res.success && res.data.results.length) {
      const labelList: any[] = []
      const arrPromise: any[] = []
      // 2 -> 再根据所有的标签分类去获取一级分类标签
      for (let i = 0; i < res.data.results.length; i++) {
        const item = res.data.results[i]
        labelList.push({
          label: item.labelName
        })
        arrPromise.push(listOneLabel({
          labelId: item.labelId
        }))
      }
      // 应为产品标签分类是个数组，在存在多个的情况下  用 Promise.all 去处理
      Promise.all(arrPromise)
        .then(res => {
          // 3 -> 处理所有拿到 一级分类标签
          for (let i = 0; i < res.length; i++) {
            const item = res[i]
            // type： 1 百灵文旅
            if (this.type === 1) {
              item.data.results = item.data.results.filter(it => it.tagId !== '296')
            }
            labelList[i].list = item.data.results || []
          }
          this.labelList = labelList
          const { labelId } = this.$route.query
          if (labelId) {
            this.labelId = labelId as string | number
            this.changeRadio(this.labelId)
          }
        })
    }
  }

  // 获取二级分类的标签
  private getListTwoTag (tagId: number | string) {
    listTwoTag({
      tagId
    })
      .then(res => {
        if (res.success) {
          this.TwoTagList = res.data.map(item => {
            const obj = {
              labelName: item.labelVoList[0].labelName,
              list: item.labelVoList[0].labelResponseList
            }
            return obj
          })
          const { tagIds } = this.$route.query
          if (tagIds) {
            this.tagIdsList = (tagIds as string).split(',')
            this.handleChange()
          }
        }
      })
  }

  @Emit('change')
  private handleChange () {
    return {
      minPrice: this.minPrice,
      maxPrice: this.maxPrice,
      tagIds: this.tagIdsList.join(',')
    }
  }

  @Emit('clear')
  handleClear () {
    const el:any = this.$refs.radioFiltrate
    el[0].values = ''
    this.minPrice = ''
    this.maxPrice = ''
    return {
      minPrice: this.minPrice,
      maxPrice: this.maxPrice,
      tagIds: this.tagIdsList.join(','),
      labelId: '',
      clear: true
    }
  }

  mounted (): void {
    this.getListLabel()
  }
}
